import { Skeleton } from "./skeleton";
import { TableCell, TableRow } from "./table";
import type { Table } from "@tanstack/react-table";

export const SkeletonTableBody = ({
  pageSize,
  columnsLength,
  table,
}: {
  pageSize: number;
  columnsLength?: number;
  table?: Table<any>;
}) => {
  const headers = table?.getFlatHeaders() || [];
  const finalColumnsLength = headers.length > 0 ? headers.length : (columnsLength ?? 0);

  return (
    <>
      {Array.from({ length: pageSize }).map((_, index) => (
        <TableRow key={index}>
          {Array.from({ length: finalColumnsLength }).map((_, cellIndex) => (
            <TableCell key={cellIndex}>
              <Skeleton className="h-4 w-full" />
            </TableCell>
          ))}
        </TableRow>
      ))}
    </>
  );
};
